import { render, staticRenderFns } from "./PaymentInvoiceBlockMem.vue?vue&type=template&id=1631a4e3&"
import script from "./PaymentInvoiceBlockMem.vue?vue&type=script&lang=js&"
export * from "./PaymentInvoiceBlockMem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports